import { ChangePasswordSuccessPage } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ChangePasswordSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ChangePasswordSuccessPage
      backText={t('common.buttons.backToMyAccount')}
      buttonText={t('page.account.changePasswordSuccess.button')}
      onBack={() => navigate('/account')}
      onDone={() => navigate('/account')}
      title={t('page.account.changePasswordSuccess.title')}
    />
  );
};

export { ChangePasswordSuccess };
